export default __webpack_public_path__ + "static/media/news2.52a9b7be.jpg";